import {
  CenterPos,
  HeaderRow,
  ResultsColumnHeader,
  TitleText,
  TitleTextLight,
} from './DTRbiHockeyChallengeWidget.styles';
import React from 'react';
import { GameHistoryItem } from './GameHistoryItem';

export const COLUMN_WIDTH = {
  date: '20%',
  picks: '20%',
  prize: '15%',
  streak: '10%',
  challenge: '25%',
  details: '10%',
};

const MAX_RECENT_GAMES = 15;

export const GameHistory = ({ history, selectedChallengeId, handleChangeSelectedChallengeId, currentChallenges }) => {
  return (
    <>
      <TitleText>
        Game History <TitleTextLight>({`${MAX_RECENT_GAMES} most recent`})</TitleTextLight>
      </TitleText>
      <HeaderRow>
        <ResultsColumnHeader $width={COLUMN_WIDTH.date}>DATE</ResultsColumnHeader>
        <ResultsColumnHeader $width={COLUMN_WIDTH.picks}>PLAYER PICKS</ResultsColumnHeader>
        <ResultsColumnHeader $width={COLUMN_WIDTH.prize}>PRIZE EARNED</ResultsColumnHeader>
        <ResultsColumnHeader $justifyContent={'center'} $width={COLUMN_WIDTH.streak}>
          STREAK
        </ResultsColumnHeader>
        <ResultsColumnHeader $width={COLUMN_WIDTH.challenge}>CHALLENGE WEEK</ResultsColumnHeader>
        <ResultsColumnHeader $width={COLUMN_WIDTH.details}>
          <CenterPos>DETAILS</CenterPos>
        </ResultsColumnHeader>
      </HeaderRow>
      {history.slice(0, MAX_RECENT_GAMES).map((challenge) => {
        const challengeWeek = currentChallenges.find((currentChallenge) => {
          return (
            new Date(challenge.contestDate) >= currentChallenge.startDate &&
            new Date(challenge.contestDate) <= currentChallenge.endDate
          );
        });

        return (
          <GameHistoryItem
            key={challenge.contestDate}
            {...challenge}
            history={history}
            challengeId={challenge.contestDate}
            selectedChallengeId={selectedChallengeId}
            handleChangeSelectedChallengeId={handleChangeSelectedChallengeId}
            picks={challenge.picks}
            challengeWeek={challengeWeek}
            offers={challenge.offers}
            points={challenge.points}
          />
        );
      })}
    </>
  );
};
